import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FeatureFlagDirective } from '@coin/shared/core/feature-directives';
import { KeyboardMenuNavigationDirective } from '@coin/shared/core/util-directives';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FeatureFlagDirective, RouterLink, KeyboardMenuNavigationDirective],
  host: {
    '(keydown.code.Escape)': 'toggleFooter()'
  }
})
export class FooterComponent {
  showFooter = signal(false);
  footerTabindex = computed<number>(() => (this.showFooter() ? 0 : -1));

  currentYear = new Date().getFullYear();

  toggleFooter = () => this.showFooter.set(!this.showFooter());
}
